import { render, staticRenderFns } from "./TableActionMerchantManagement.vue?vue&type=template&id=4628cca7"
import script from "./TableActionMerchantManagement.vue?vue&type=script&lang=js"
export * from "./TableActionMerchantManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports